import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello, I'm <span className="purple">Hamza Ayoub </span>, hailing
            from from{" "}
            <span className="purple"> Lahore, Punjab , Pakistan.</span>
            <br />A Software Engineering graduate from KFUEIT, RYK. I specialize
            in full-stack development, leveraging JavaScript, Node.js, and
            React.js to create innovative web solutions. My passion for crafting
            impactful digital experiences is fueled by a strong analytical
            mindset, coupled with a keen eye for design and problem-solving.
            Committed to continuous learning, I thrive on challenges that
            contribute to my professional growth while delivering exceptional
            results.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Cricket / Bedminton
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading Books
            </li>
          </ul>

          <p style={{ color: "rgb(117 244 214)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
